// 使い方（2026-10-21 に app.js から分けた）
import { S } from './state.js';
import { txt } from './text.js';
import { $ } from './util.js';
import { tallUI } from './store.js';
import { openSlots } from './slots.js';
import { toggleMenu } from './dialog.js';
import type { TourStep } from './state.js';

// ---- 使い方（まわりを暗くして、1つずつ照らす） ----
// はじめて開いたときの「同意して、使い方を見る」と、ロゴのメニューの「使い方を見る」から。5手順（種類とパーツ・色・キャラの上・調整・ランダム／セーブ／完成）。
// 今の画面に無いもの（たたんだ色の段・出ていない調整の列など）は飛ばす。本物の CHARAT には使い方の案内は無い
export const touchUI = window.matchMedia('(hover: none), (pointer: coarse)').matches;
export const TOUR: TourStep[] = [
  // sel が配列なら、全部をまとめて囲む
  { sel: ['#cats', '#parts'], title: txt('tour_parts'), text: txt('tour_parts_text') },
  { sel: '#colorsFold', title: txt('tour_colors'), text: txt('tour_colors_text') },
  { sel: '#stage', title: txt('tour_stage'), text: txt(touchUI ? 'tour_stage_touch' : 'tour_stage_mouse') },
  // 全身のメーカーのスマホは、道具の列はふだん出ていないので右の列（元に戻す・色・柄・調整）を照らす
  { sel: tallUI ? '#sideRail' : '#tools', title: txt('tour_tools'), text: txt(tallUI ? 'tour_tools_text_side' : 'tour_tools_text') },
  { sel: '.float.tr', title: txt('tour_top'), text: txt('tour_top_text') }
];
// 照らす範囲。sel が配列なら、見えている要素すべてを囲む矩形（1つも無ければ null）
export function tourTarget(step: TourStep): { left: number; top: number; right: number; bottom: number } | null {
  if (!step.sel) return null;
  let sels = Array.isArray(step.sel) ? step.sel : [step.sel], box: { left: number; top: number; right: number; bottom: number } | null = null;
  sels.forEach((sel) => {
    const node = document.querySelector<HTMLElement>(sel);
    if (!node || node.hidden) return;
    const r = node.getBoundingClientRect();
    if (r.width <= 4 || r.height <= 4) return;
    box = box
      ? { left: Math.min(box.left, r.left), top: Math.min(box.top, r.top), right: Math.max(box.right, r.right), bottom: Math.max(box.bottom, r.bottom) }
      : { left: r.left, top: r.top, right: r.right, bottom: r.bottom };
  });
  return box;
}
// steps: 照らす手順（省くと使い方の全部）。1つだけのとき（同意のあとの「使い方はここから」）は、何手順目か・点・スキップを出さない
export function startTour(steps?: TourStep[]) {
  toggleMenu(false);
  S.tourSteps = (Array.isArray(steps) ? steps : TOUR).filter((s) => !s.sel || tourTarget(s));
  if (!S.tourSteps.length) return;
  $('tour').classList.toggle('single', S.tourSteps.length === 1);
  S.tourIdx = 0;
  $('tour').hidden = false;
  $('tourDots').innerHTML = S.tourSteps.map(() => '<i></i>').join('');
  showTourStep(true);
}
// instant: 動きを付けずに置く（はじめ・画面の大きさが変わったとき）
export function showTourStep(instant?: boolean) {
  const step = S.tourSteps[S.tourIdx], hole = $('tourHole'), tip = $('tourTip');
  $('tourStep').textContent = (S.tourIdx + 1) + ' / ' + S.tourSteps.length;
  $('tourTitle').textContent = step.title;
  $('tourText').textContent = step.text;
  $('tourNext').textContent = txt(S.tourIdx === S.tourSteps.length - 1 ? 'tour_start' : 'tour_next');
  $('tourDots').querySelectorAll('i').forEach((d, i) => { d.classList.toggle('on', i === S.tourIdx); });
  hole.classList.toggle('instant', !!instant);
  let vw = innerWidth, vh = innerHeight, pad = 6, r = tourTarget(step), box: { l: number; t: number; r: number; b: number } | null = null;
  if (r) {
    box = { l: Math.max(6, r.left - pad), t: Math.max(6, r.top - pad), r: Math.min(vw - 6, r.right + pad), b: Math.min(vh - 6, r.bottom + pad) };
    hole.style.left = box.l + 'px'; hole.style.top = box.t + 'px';
    hole.style.width = (box.r - box.l) + 'px'; hole.style.height = (box.b - box.t) + 'px';
  } else {
    hole.style.left = vw / 2 + 'px'; hole.style.top = vh / 2 + 'px'; hole.style.width = '0px'; hole.style.height = '0px';
  }
  // 吹き出しは、照らした所の下・上・左・右のうち入る側に（どれも入らなければ画面の下に重ねる）
  let tw = tip.offsetWidth, th = tip.offsetHeight, gap = 14, m = 12, x, y;
  const clampX = (v: number) => Math.max(m, Math.min(vw - tw - m, v));
  const clampY = (v: number) => Math.max(m, Math.min(vh - th - m, v));
  if (!box) { x = (vw - tw) / 2; y = (vh - th) / 2; }
  else if (vh - box.b >= th + gap + m) { y = box.b + gap; x = clampX((box.l + box.r - tw) / 2); }
  else if (box.t >= th + gap + m) { y = box.t - gap - th; x = clampX((box.l + box.r - tw) / 2); }
  else if (box.l >= tw + gap + m) { x = box.l - gap - tw; y = clampY((box.t + box.b - th) / 2); }
  else if (vw - box.r >= tw + gap + m) { x = box.r + gap; y = clampY((box.t + box.b - th) / 2); }
  else { x = (vw - tw) / 2; y = vh - th - m; }
  tip.style.left = x + 'px';
  tip.style.top = y + 'px';
  if (instant) { void hole.offsetWidth; hole.classList.remove('instant'); }
  $('tourNext').focus({ preventScroll: true });
}
export function nextTour() {
  if (S.tourIdx < S.tourSteps.length - 1) { S.tourIdx++; showTourStep(false); }
  else endTour();
}
export function endTour() {
  $('tour').hidden = true;
  S.tourIdx = -1;
}
export function bindTour() {
  $('tourNext').addEventListener('click', nextTour);
  $('tourSkip').addEventListener('click', endTour);
  $('btnTour').addEventListener('click', () => { startTour(); });
  $('btnTemplate').addEventListener('click', () => { toggleMenu(false); openSlots('preset'); });
  document.addEventListener('keydown', (e) => {
    if (S.tourIdx < 0) return;
    if (e.key === 'Escape') { e.stopPropagation(); endTour(); }
    if (e.key === 'ArrowRight') nextTour();
  }, true);
  window.addEventListener('resize', () => { if (S.tourIdx >= 0) showTourStep(true); });
}
